import React from 'react';
import { TrendingDown, AlertCircle, Brain, Target, CheckCircle } from 'lucide-react';
import { problems } from '../data/mockData';

const iconMap = {
  TrendingDown,
  AlertCircle,
  Brain,
  Target
};

const ProblemSolution = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Struggling with <span className="text-red-600">Trading Losses?</span>
          </h2>
          <p className="text-lg text-gray-600">
            You're not alone. Most traders face these common challenges
          </p>
        </div>

        {/* Problems Grid */}
        <div className="max-w-5xl mx-auto mb-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {problems.map((item) => {
              const IconComponent = iconMap[item.icon];
              return (
                <div 
                  key={item.problem}
                  className="bg-red-50 border border-red-200 rounded-xl p-6 hover:shadow-lg transition-shadow duration-300"
                >
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center">
                      <IconComponent className="h-6 w-6 text-red-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-2">{item.problem}</h3>
                      <p className="text-sm text-gray-600">{item.impact}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Solution */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-green-50 to-white border-2 border-green-600 rounded-2xl p-8 sm:p-10 shadow-xl">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-600 rounded-full mb-4">
                <CheckCircle className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                The Solution: <span className="text-green-600">Structured Learning</span>
              </h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                At <span className="font-semibold text-green-700">Stocks Vision Academy, Bhopal</span>, we don't just teach theory. 
                We focus on practical, execution-oriented training with strong emphasis on risk management.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-green-200">
                <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Learn with real-time market examples</span>
              </div>
              <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-green-200">
                <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Master risk and money management</span>
              </div>
              <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-green-200">
                <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Control emotions & trade discipline</span>
              </div>
              <div className="flex items-start gap-3 bg-white p-4 rounded-lg border border-green-200">
                <CheckCircle className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                <span className="text-gray-700">Get continued support after course</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
